import { Layout } from "providers/Layout";
import { BoomCrmPaywall } from "./BoomCrmPaywall";
import { PageSkeleton } from "./PageSkeleton";
import { PAYWALL_COPY, type PaywallFeature } from "./constants";

interface PaywallScreenProps {
  feature: PaywallFeature;
}

const PAGE_TITLE: Record<PaywallFeature, string> = {
  leads: "Leads",
  tasks: "Tasks",
  connectedEmails: "Communication",
  customEmailTemplates: "Communication",
  email: "Inbox",
  call: "Inbox",
  showings: "Showings",
  showingsCodebox: "Showings",
  lockboxes: "Lockboxes",
  phoneNumbers: "Phone numbers",
  phoneNumbersLimit: "Phone numbers",
  workflows: "Workflows",
  workflowsLimit: "Workflows",
  communicationCampaigns: "Campaigns",
  syndication: "Syndication",
  listingSettings: "Listing settings",
  listings: "Listings",
  listingsPage: "Listings page",
  customizeLeadSourcesStages: "CRM",
  // LEGACY ANALYTICS TABS: goes with the `analytics` paywall entry.
  analytics: "Analytics",
  aiLeasingAgent: "AI agents",
  callCoach: "Calls"
};

/**
 * Renders the paywall card centered over a blurred page-skeleton bg.
 */
export const PaywallScreen = ({ feature }: PaywallScreenProps) => {
  return (
    <Layout sectionClassName="!p-0">
      <div className="relative h-full w-full overflow-hidden bg-background-900">
        <div className="absolute inset-0 flex flex-col">
          <div className="shrink-0 px-6 pt-6 pb-2">
            <h1 className="text-2xl font-bold text-content-1000">
              {PAGE_TITLE[feature]}
            </h1>
          </div>
          <div className="flex-1 overflow-hidden">
            <PageSkeleton feature={feature} />
          </div>
        </div>
        <div
          className="absolute inset-0 z-10 flex items-center justify-center p-4"
          style={{
            backgroundColor: "rgba(255,255,255,0.1)",
            backdropFilter: "blur(4px)",
            WebkitBackdropFilter: "blur(4px)"
          }}
        >
          <BoomCrmPaywall {...PAYWALL_COPY[feature]} />
        </div>
      </div>
    </Layout>
  );
};
